export function hexToRgb(c, a) {
  if (/^#([a-f0-9]{3}){1,2}$/.test(c)) {
      if (c.length == 4) {
          c = '#' + [c[1], c[1], c[2], c[2], c[3], c[3]].join('');
      }
      c = '0x' + c.substring(1);
      // tslint:disable-next-line: no-bitwise
      if (a) {
        return 'rgb(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ', ' + a + ')';
      }
      return 'rgb(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ')';
  }
  return '';
}

export function rgbToHex(rgb) {
  let c = rgb.match(/\d+(\.\d+)?%?/g);
  if (c) {
      c = c.slice(0, 3).map(function(next) {
          let itm = next;
          if (itm.indexOf('%') != -1) {
              itm = Math.round(parseFloat(itm) * 2.55);
          }
          if (itm < 0) { itm = 0; }
          if (itm > 255) { itm = 255; }
          itm = Math.round(itm).toString(16);
          if (itm.length === 1) { itm = '0' + itm; }
          return itm;
      });
      return '#' + c.join('').toLowerCase();
  }
  return '';
}
